import React, { useRef, useEffect, useState } from "react";
import './Collapse.scss';
import { observer } from "mobx-react-lite";
import { useResizeObserver } from "../effects/useScrollPosition";


const Collapse = observer(({ children, title, isOpen = false, onOpen, onClose, className = '', onClick }) => {
    const [open, setOpen] = useState(isOpen);
    const [animating, setAnimating] = useState(false);
    const [closed, setClosed] = useState(!isOpen);
    const { dimensions, elRef } = useResizeObserver();
    const contentRef = useRef(null);

    useEffect(() => {
        setOpen(isOpen);
        setClosed(!isOpen);
    }, [isOpen]);

    useEffect(() => {
        contentRef.current.style.height = open ? `${contentRef.current.scrollHeight}px` : "0px";
        setClosed(false);
        setAnimating(true);


        var timerId = setTimeout(() => {
            // if (contentRef.current) {
            //     contentRef.current.style.height = open ? `auto` : '0px';
            // }
            if (!open) {
                setClosed(true);
            }
            setAnimating(false);
        }, 310);
        return () => {
            clearTimeout(timerId);
        }
    }, [open, children, dimensions]);

    useEffect(() => {
        if (open) {
            if (onOpen) {
                onOpen();
            }
        } else {
            if (onClose) {
                onClose();
            }
        }
    }, [open]);



    const onClickHandler = () => {
        if (onClick) {
            onClick();
        } else {

            setOpen(!open);
        }
    };

    const styles = {
        overflow: closed || animating ? 'hidden' : 'visible',
        position: 'relative',
        transition: 'height 0.3s ease-in-out',
    };
    if (open) {
        styles.padding = '1px';
    }

    if (typeof title === 'function') {
        title = title({ open, closed });
    }

    return (
        <section className={`${className} Collapse ${!open ? 'closed' : 'open'}`}>
            {title &&
                <div className="Collapse__trigger" onClick={onClickHandler}>{title}</div>
            }
            <div style={styles} className={'Collapse__content'} ref={contentRef}>
                <div className="elRef" ref={elRef}>
                    {children}
                </div>
            </div>
        </section>
    );
})

Collapse.displayName = 'Collapse';
export default Collapse;
